import { Link, useLocation } from 'react-router-dom'
import { Home, Library, Dices, User, MessageCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { routes } from '@/lib/routes'
import { useChatUnreadCount } from '@/features/chat/hooks/use-chat-unread-count'
import { useChatStore } from '@/features/chat/store/chat-store'
import { useDMUnreadCount } from '@/features/direct-messages/hooks/use-dm-unread-count'
import { useDMStore } from '@/features/direct-messages/store/dm-store'

type NavLinkProps = {
  to: string
  icon: React.ReactNode
  label: string
  currentPath: string
  unreadCount?: number
}

function NavLink({ to, icon, label, currentPath, unreadCount }: NavLinkProps) {
  const isActive = currentPath === to

  return (
    <Link
      to={to}
      className={cn(
        "flex flex-col items-center gap-1 p-2 transition-colors",
        {
          "text-foreground": isActive,
          "text-muted-foreground hover:text-foreground": !isActive
        }
      )}
    >
      <div className="relative h-5 w-5">
        {icon}
        {typeof unreadCount === 'number' && unreadCount > 0 && (
          <span
            aria-label={`${unreadCount} mensagens não lidas`}
            className="absolute -top-2.5 -right-4 min-h-4 min-w-4 px-0.5 rounded-full bg-red-600 text-white text-[10px] leading-none font-medium flex items-center justify-center shadow"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </div>
      <span className="text-xs">{label}</span>
    </Link>
  )
}

export function Navbar() {
  const location = useLocation()
  
  // Carrega contadores de mensagens não lidas (chat global + DMs)
  useChatUnreadCount()
  useDMUnreadCount()
  
  const globalUnreadCount = useChatStore((state) => state.unreadCount)
  const dmTotalUnreadCount = useDMStore((state) => state.totalUnreadCount)
  const totalUnreadMessages = globalUnreadCount + dmTotalUnreadCount

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background/80 backdrop-blur-sm">
      <div className="mx-auto w-full max-w-screen-xl px-4">
        <div className="flex items-center justify-around py-2">
          <NavLink to="/" icon={<Home />} label="Home" currentPath={location.pathname} />
          <NavLink to={routes.messages} icon={<MessageCircle />} label="Chat" currentPath={location.pathname} unreadCount={totalUnreadMessages} />
          <NavLink to="/roll" icon={<Dices />} label="Roll" currentPath={location.pathname} />
          <NavLink to="/inventory" icon={<Library />} label="Inventário" currentPath={location.pathname} />
          <NavLink to="/profile" icon={<User />} label="Perfil" currentPath={location.pathname} />
        </div>
      </div>
    </nav>
  )
} 